import React, { Component } from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';

import {
  SR_API_ACTION_ASSIGN_LEAD_APARTMENT_LOCATOR,
} from 'api/actionTypes';
import { SCREEN_ID_RESET_PASSWORD_CONFIRM } from 'client/constants/screenIds';

import { getUserLandingPage } from 'client/helpers/allowedRoles';

import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import postWithState from 'client/actions/postWithState';

import SrPasswordResetForm from 'client/components/SrPasswordResetForm';
import Navbar from 'client/components/Navbar';
import SrLink from 'client/components/SrLink/SrLink';

import AuthActions from 'client/actions/Auth';
import TourActions from 'client/actions/Tour';
import UserActions from 'client/actions/User';

@withTransitionHook
@branch({
  isMobileApp: ['mobileApp', 'isMobileApp'],
})
@withScreenId(SCREEN_ID_RESET_PASSWORD_CONFIRM)
@withScrollToTop
class ResetPasswordConfirmPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Rentals',
    section: SCREEN_ID_RESET_PASSWORD_CONFIRM,
    keywords: 'sunroom, reset password',
    description: 'Reset your sunroom password.',
  })

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    isMobileApp: PropTypes.bool.isRequired,
  }

  constructor(props) {
    super(props);
    this.redirectUser = this.redirectUser.bind(this);
  }

  onPasswordResetFormSubmit = (formValues) => {
    const { dispatch, location } = this.props;
    const { token } = queryString.parse(location.search);
    dispatch(AuthActions.resetPasswordRequested, {
      token: token,
      password: formValues.password,
    }).then(({ user }) => this.redirectUser(user));
  }

  async redirectUser(user) {
    const { dispatch, location, history, isMobileApp } = this.props;
    const locationQuery = queryString.parse(location.search);

    if (locationQuery.tourRequested) {
      dispatch(TourActions.requestShowingStepSubmit, {
        listingId: parseInt(locationQuery.tourRequested, 10),
        history: history,
        locationQuery: locationQuery,
      });
    }
    else if (locationQuery.bookmarkRequested) {
      await dispatch(UserActions.addBookmark, {
        listingId: parseInt(locationQuery.bookmarkRequested, 10),
      });
      history.push('/saved');
    }
    else if (locationQuery.invitedBy) {
      await dispatch(postWithState, {
        action: SR_API_ACTION_ASSIGN_LEAD_APARTMENT_LOCATOR,
        payload: {
          userId: user.id,
          assignmentContext: 'Invite Link',
          enableSmsMessage: false,
          canOverwrite: false,
          apartmentLocatorUserId: parseInt(locationQuery.invitedBy, 10),
        },
      });
    }
    else if (locationQuery.userName && locationQuery.listingAddress) {
      history.push('/tour');
    }
    else {
      const userLandingPage = getUserLandingPage({
        userRoles: user.roles,
        isMobileApp: isMobileApp,
      });
      history.push(userLandingPage);
    }
  }

  render() {
    const { location } = this.props;

    return (
      <div className='page-reset-password'>
        <Navbar
          redirectLogoTo='/'
          leftButton={
            <SrLink
              className='link back'
              redirectToLastLocation
              restoreScrollPosition
              to='/reset-password-verify-code'
            >
              Back
            </SrLink>
          }
        />
        <div className='resetContainer'>
          <div className='resetFormContainer'>
            <SrPasswordResetForm
              onSubmit={this.onPasswordResetFormSubmit}
              locationQuery={queryString.parse(location.search)}
            />
          </div>
        </div>
      </div>
    );
  }
}

ResetPasswordConfirmPage.displayName = 'ResetPasswordConfirmPage';

export default ResetPasswordConfirmPage;
